/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';

import { serverBaseWebSocketUrl } from '../../general-utilities/urlUtils';
import { campaignRootStore } from '../../stores/CampaignRootStore';

interface ImageControllerProps {
  orgId: number;
  campaignId: string;
  droneUuid: string;
}

export const ImageController = observer(({ orgId, campaignId, droneUuid }: ImageControllerProps) => {
  const { t } = useTranslation();

  const connect = (): void => {
    const { socket } = campaignRootStore.imageStore;

    if (socket || !orgId || !campaignId || !droneUuid) {
      return;
    }

    const wsConnectionStr = `${serverBaseWebSocketUrl}/ws/org/${orgId}/campaign/${campaignId}/drone/${droneUuid}/multispectral-images/`;

    const socketNew = new WebSocket(wsConnectionStr);

    campaignRootStore.imageStore.updateSocket(socketNew);

    socketNew.onopen = () => {
      campaignRootStore.imageStore.updateIsConnected(true);
    };

    socketNew.onmessage = (event: MessageEvent) => {
      runInAction(() => {
        const imageMetadataFetched = JSON.parse(event.data);
        campaignRootStore.imageStore.updateImageMetadata(imageMetadataFetched);
      });
    };

    socketNew.onclose = () => {
      runInAction(() => {
        campaignRootStore.imageStore.updateIsConnected(false);
        campaignRootStore.imageStore.updateSocket(null);
      });
    };

    socketNew.onerror = () => {
      toast.error(t('general_errors.connection_error'));
      socketNew.close();
    };
  };

  const disconnect = (): void => {
    const { socket } = campaignRootStore.imageStore;

    if (socket) {
      socket.close();
      campaignRootStore.imageStore.updateIsConnected(false);
      campaignRootStore.imageStore.updateSocket(null);
    }
  };

  useEffect(() => {
    connect();

    return () => disconnect();
  }, []);

  return null;
});
